// TODO: 중복제거
import { renderDataTypeWithComma } from "@/lib/utils/renderType";
import { isBooksProduct } from "src/api/booksProducts";
import { CurriculumsWithString, GradesWithString, Subjects, SubjectsWithString } from "src/api/product";
// TODO: remove publisherName parameter
//수업자료
export default function coreInfoList(product, publisherName) {
    if (isBooksProduct(product)) {
        return [
            {
                type: "과목",
                value: SubjectsWithString[product.subject]
            },
            {
                type: "출판사",
                value: publisherName
            },
            {
                type: "학년",
                value: CurriculumsWithString[product.curriculum] + product.grades.map((grade)=>GradesWithString[grade]).join(", ")
            }
        ];
    }
    const { subject , curriculum , grade , based_textbook_title , genre , era , question_number , unit , publisher  } = product.source// TODO: remove type assertion
    ;
    const subjectValue = SubjectsWithString[subject];
    const gradeValue = CurriculumsWithString[curriculum] + GradesWithString[grade];
    // TODO: remove type assertion
    const dataTypeValue = renderDataTypeWithComma(product.source.data_type);
    switch(product.source_type){
        case "handout":
            var _product_source;
            if (subject === Subjects.KO) {
                return [
                    {
                        type: "과목",
                        value: subjectValue
                    },
                    {
                        type: "출처작품",
                        value: based_textbook_title
                    },
                    {
                        type: "장르",
                        value: genre
                    },
                    {
                        type: "시대",
                        value: era
                    },
                    {
                        type: "문항 수",
                        value: question_number
                    },
                    {
                        type: "학년",
                        value: gradeValue
                    }
                ];
            }
            return [
                {
                    type: "과목",
                    value: subjectValue
                },
                {
                    type: "출처교재",
                    value: based_textbook_title,
                    link: "/products/".concat(product === null || product === void 0 ? void 0 : (_product_source = product.source) === null || _product_source === void 0 ? void 0 : _product_source.product_id)
                },
                {
                    type: "단원",
                    value: unit
                },
                {
                    type: "자료유형",
                    value: dataTypeValue
                },
                {
                    type: "문항 수",
                    value: question_number
                },
                {
                    type: "학년",
                    value: gradeValue
                }
            ];
        case "textbook":
        case "workbook":
            return [
                {
                    type: "과목",
                    value: subjectValue
                },
                {
                    type: "출판사",
                    value: publisherName
                },
                {
                    type: "학년",
                    value: gradeValue
                }
            ];
        case "work":
            return [
                {
                    type: "과목",
                    value: subjectValue
                },
                {
                    type: "저작권자",
                    value: publisher
                },
                {
                    type: "장르",
                    value: genre
                },
                {
                    type: "시대",
                    value: era
                }
            ];
    }
}
